import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface UserPreferences {
  theme?: 'light' | 'dark' | 'system' | 'high-contrast';
  defaultPov?: string;
  defaultTense?: string;
  defaultNarrativeStyle?: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function usePreferences() {
  const { getToken } = useAuth();
  return useQuery<UserPreferences | null>({
    queryKey: ['preferences'],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const response = await client
        .get('api/v2/me/preferences')
        .json<ApiResponse<UserPreferences | null>>();
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
}

export function useUpdatePreferences() {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (prefs: UserPreferences) => {
      const client = createApiClient(getToken);
      await client.put('api/v2/me/preferences', { json: prefs });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['preferences'] }),
  });
}
